module.exports = __webpack_public_path__ + "static/preview-img1@2x-62bbea396dbcb3718ba9251a81bec206.png";